import { processAPIResponse } from '@/utils/request';
import { fetchSkillsRequest } from '@/services/api/skill';
import { SkillModel } from '@/typings/models/Skill';

const initialState: { list: SkillModel[]; initialized: boolean; drawerOpen: boolean } = {
  list: [],
  initialized: false,
  drawerOpen: false,
};

export default {
  namespace: 'skills',

  state: initialState,

  effects: {
    *fetch(_, { call, put }) {
      const { response, data } = yield call(fetchSkillsRequest);
      yield processAPIResponse({ response, data }, {
        *onSuccess(list) {
          yield put({ type: 'save', payload: list || [] });
        },
      }, 'data');
    },
  },

  reducers: {
    save(state, { payload }) {
      return { ...state, list: payload, initialized: true };
    },
    openDrawer(state) {
      return { ...state, drawerOpen: true };
    },
    closeDrawer(state) {
      return { ...state, drawerOpen: false };
    },
    reset() {
      return initialState;
    },
  },
};
